import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Box, Flex } from "@similarweb/ui-components/foundations";

export const FileItemSkeleton = () => (
    <Flex
        gap="25px"
        margin="20px 0 0"
        padding="0 14px 0 7px"
    >
        <PixelPlaceholderLoader
            width={120}
            height={16}
        />
        <Box
            margin="0 0 0 auto"
            height="16px"
        >
            <PixelPlaceholderLoader
                width={76}
                height={16}
            />
        </Box>
        <PixelPlaceholderLoader
            width={16}
            height={16}
        />
    </Flex>
);
